export const exposiciones = [
    {
        "nombre" : "Geositios del Geoparque de la Comarca Minera",
        "descripcion" : "Exposición fotográfica",
        "icono": "exposicion1.jpeg",
            
    },
    {
        "nombre" : "Contrastes de la vida cotidiana",
        "descripcion" : "Fotografías de principios del siglo XX",
        "icono": "exposicion2.jpeg",
     
    },
    {
        "nombre" : "Justicia en el Virreinato de la Nueva España",
        "descripcion" : "Exposición documental 1630-1811",
        "icono": "exposicion3.jpeg",
      
    },
    
]